import { useParams, useRoute } from 'wouter-preact'

import { Dropdown, HamburgerMenuIcon, Notifications } from 'components/UI'

import { UserMenu } from './UserMenu'
import { SmartContractMenu } from './SmartContractMenu'
import { CodigoLogoButton } from './CodigoLogoButton'

const Header = ({ toggleSidebar }: { toggleSidebar?: () => void }) => {
	const params = useParams()
	const [isOnDashboardPage] = useRoute('/')

	const projectId = params ? params?.projectId : null

	return (
		<header class='sticky top-0 z-10 w-full border-b border-b-black-800 bg-black-900 p-4'>
			<nav class='mx-auto flex h-full items-center justify-between px-1'>
				<div class='flex items-center gap-4'>
					{toggleSidebar && (
						<button
							aria-label='Toggle sidebar'
							class='h-[1.5rem] w-[1.5rem] hover:text-product'
							onClick={toggleSidebar}
							type='button'
						>
							<HamburgerMenuIcon />
						</button>
					)}

					<CodigoLogoButton />
				</div>

				<Dropdown />

				<div class='flex items-center gap-5'>
					{!(isOnDashboardPage && projectId) && <SmartContractMenu />}
					<Notifications />
					<UserMenu />
				</div>
			</nav>
		</header>
	)
}

export { Header }
